// @flow
import React from 'react'
import { defaultTo, noop, stubString } from 'lodash/util'

import DrawerMobile from './DrawerMobile'
import DrawerDesktop from './DrawerDesktop'
import hardCodedProducts from '../../../hardCodedData/menuProducts'
import links from './links.js'

export const CONTAINER_MAX_WIDTH = 1200
export const DRAWER_WIDTH = 300

type State = {
  isOpen: boolean
}

type Props = {
  availableLanguages: Array<Object>,
  background: string,
  catalogID: string,
  changeLanguage: Function,
  color: string,
  freeDeliveryMessage: boolean,
  isAtMobileView: boolean,
  isAtHomePage: boolean,
  isAuthenticated: boolean,
  isPermanentlyOpen: boolean,
  language: string,
  multiLanguagesPaths: Object,
  navigateTo: Function,
  productID: number,
  staticPageID: string,
  width: string
}

export class Drawer extends React.Component<Props, State> {
  static defaultProps: Object
  state = {
    isOpen: defaultTo(this.props.isPermanentlyOpen, false)
  }

  componentDidMount () {
    !this.props.isPermanentlyOpen &&
      !this.props.isAtMobileView &&
      window.addEventListener('mousemove', this.mousePositionX)
  }

  mousePositionX: Function = (e: Object) => {
    if (
      this.state.isOpen &&
      (e.clientX >
        (window.innerWidth - CONTAINER_MAX_WIDTH) / 2 + DRAWER_WIDTH ||
        e.clientX < (window.innerWidth - CONTAINER_MAX_WIDTH) / 2)
    ) {
      this.setState({
        isOpen: false
      })
    }
  }

  toggleDrawer: Function = () => {
    this.setState({ isOpen: !this.state.isOpen })
  }

  componentWillUnmount () {
    !this.props.isPermanentlyOpen &&
      window.removeEventListener('mousemove', this.mousePositionX)
  }

  render () {
    return this.props.isAtMobileView ? (
      <DrawerMobile
        availableLanguages={this.props.availableLanguages}
        catalogID={this.props.catalogID}
        changeLanguage={this.props.changeLanguage}
        color={this.props.color}
        hardCodedProducts={hardCodedProducts}
        isAuthenticated={this.props.isAuthenticated}
        isOpen={this.state.isOpen}
        language={this.props.language}
        links={links}
        productID={this.props.productID}
        navigateTo={this.props.navigateTo}
        staticPageID={this.props.staticPageID}
        toggleDrawer={this.toggleDrawer}
        multiLanguagesPaths={this.props.multiLanguagesPaths}
      />
    ) : (
      <DrawerDesktop
        background={this.props.background}
        catalogID={this.props.catalogID}
        color={this.props.color}
        freeDeliveryMessage={this.props.freeDeliveryMessage}
        hardCodedProducts={hardCodedProducts}
        isAtHomePage={this.props.isAtHomePage}
        isOpen={this.state.isOpen}
        isPermanentlyOpen={this.props.isPermanentlyOpen}
        links={links}
        productID={this.props.productID}
        staticPageID={this.props.staticPageID}
        toggleDrawer={this.toggleDrawer}
        width={this.props.width}
      />
    )
  }
}

Drawer.defaultProps = {
  background: 'white',
  changeLanguage: noop,
  productID: stubString(),
  catalogID: stubString(),
  staticPageID: stubString(),
  freeDeliveryMessage: false,
  isPermanentlyOpen: false,
  language: stubString(),
  availableLanguages: []
}

export default Drawer
